/**
 * Article Advanced — Table of contents + scroll spy
 * Compatible with Shopify Be Yours / Online Store 2.0
 */
(function () {
  'use strict';

  const content = document.querySelector('[data-article-content]');
  const tocList = document.querySelector('[data-article-toc-list]');
  const tocBar = document.querySelector('[data-article-toc-bar]');

  if (!content) return;

  // Collect headings inside the article content
  const headings = Array.from(content.querySelectorAll('h2, h3'));

  // Captions remain useful even when an article has no headings/TOC.
  Array.from(content.querySelectorAll('img[alt], img[data-alt]')).forEach(function (image) {
    const altText = (image.getAttribute('alt') || image.getAttribute('data-alt') || '').trim();
    if (!altText || image.nextElementSibling && image.nextElementSibling.classList.contains('article-advanced__image-caption')) return;
    const caption = document.createElement('p');
    caption.className = 'article-advanced__image-caption';
    caption.textContent = altText;
    image.insertAdjacentElement('afterend', caption);
  });

  if (!headings.length) return;

  // Assign IDs and build TOC data
  const tocItems = headings.map(function (heading, index) {
    const id = heading.id || 'section-' + (index + 1);
    heading.id = id;
    return {
      id: id,
      text: heading.textContent.trim(),
      level: heading.tagName.toLowerCase()
    };
  });

  function buildList(items) {
    if (!tocList) return;
    tocList.innerHTML = '';
    items.forEach(function (item) {
      const li = document.createElement('li');
      li.className = item.level === 'h3' ? 'level-h3' : 'level-h2';
      const a = document.createElement('a');
      a.href = '#' + item.id;
      a.textContent = item.text;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        scrollToSection(item.id);
      });
      li.appendChild(a);
      tocList.appendChild(li);
    });
  }

  function buildBar(items) {
    if (!tocBar) return;
    tocBar.innerHTML = '';
    items.forEach(function (item) {
      const a = document.createElement('a');
      a.href = '#' + item.id;
      a.className = 'article-advanced__toc-pill';
      a.textContent = item.text;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        scrollToSection(item.id);
      });
      tocBar.appendChild(a);
    });
  }

  function scrollToSection(id) {
    const target = document.getElementById(id);
    if (!target) return;
    const offset = window.innerWidth <= 980 ? 76 : 120;
    const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: top, behavior: 'smooth' });
    if (history.replaceState) {
      history.replaceState(null, null, '#' + id);
    }
  }

  buildList(tocItems);
  buildBar(tocItems);

  // Scroll spy
  const tocLinks = Array.from(document.querySelectorAll('[data-article-toc-list] a, [data-article-toc-bar] a'));

  function onScroll() {
    const scrollPos = window.pageYOffset + (window.innerWidth <= 980 ? 100 : 140);
    let current = tocItems[0].id;

    for (let i = 0; i < headings.length; i++) {
      if (headings[i].offsetTop <= scrollPos) {
        current = headings[i].id;
      }
    }

    tocLinks.forEach(function (link) {
      const isMatch = link.getAttribute('href') === '#' + current;
      link.classList.toggle('is-active', isMatch);
      if (isMatch && link.parentElement) {
        link.parentElement.classList.add('is-active');
      } else if (link.parentElement) {
        link.parentElement.classList.remove('is-active');
      }
    });

    // Keep active pill visible in mobile bar
    if (tocBar) {
      const activePill = tocBar.querySelector('.is-active');
      if (activePill) {
        activePill.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
